
import React from "react";
import { motion } from "framer-motion";
import { Box } from "@mui/material";

export const MotionBoxBase = motion(Box);
export const MotionBox = React.forwardRef(function MotionBox(
    { children, delay, y = 30, initial = "initial", animate = "animate", ...props },
    ref
) {
    const animation = {
        initial: { opacity: 0, y: y },
        animate: {
            opacity: 1,
            y: 0,
            transition: { duration: 1, delay: delay }
        },
    };
    return (
        <MotionBoxBase
            ref={ref}
            variants={animation}
            initial={initial}
            animate={animate}
            {...props} // user props override defaults
        >
            {children}
        </MotionBoxBase>
    );
});
